const LeavingOnAJetPlane = [
	'All my bags are packed,',
	"I'm ready to go,",
	"I'm standing here outside your door,",
	'I hate to wake you up to say good-bye.',
	'But the dawn is breaking,',
	"it's early morn,",
	"the taxi's waiting He's blowing his horn.",
	"Already I'm so lonesome I could cry.",
	'',
	'So kiss me and smile for me,',
	"tell me that you'll wait for me,",
	"hold me like you'll never let me go.",
	"'Cause I'm leaving on a jet plane,",
	"don't know when I'll be back again.",
	'Oh, babe, I hate to go.',
	'',
	"There's so many times I've let you down,",
	"so many times I've played around,",
	"I tell you now they don't mean a thing.",
	"Every place I go I'll think of you,",
	"every song I sing I'll sing for you,",
	'when I come back,',
	"I'll bring your wedding ring.",
	'',
	'So kiss me and smile for me,',
	"tell me that you'll wait for me,",
	"hold me like you'll never let me go.",
	"'Cause I'm leaving on a jet plane,",
	"don't know when I'll be back again.",
	'Oh, babe, I hate to go.',
	'',
	'Now the time has come to leave you,',
	'one more time let me kiss you,',
	'then close your eyes,',
	"I'll be on my way.",
	"Dream about the days to come when I won't have to leave alone,",
	"about the times I won't have to say:",
	'',
	'So kiss me and smile for me,',
	"tell me that you'll wait for me,",
	"hold me like you'll never let me go.",
	"'Cause I'm leaving on a jet plane,",
	"don't know when I'll be back again.",
	'Oh, babe, I hate to go.',
];

export default LeavingOnAJetPlane;
